<template>
  <a-modal :title="type=='add'? '添加角色':'编辑角色'" okText="保存" @ok="save" v-model="visible" :destroyOnClose="true" :confirmLoading="confirmLoading">
    <a-form :form="form">
      <a-form-item v-bind="formItemLayout" label="名称">
        <a-input placeholder="请填写名称,限10个字" v-decorator="['name',{rules: [{required: true, message: '请填写名称'},{max: 10, message: '限10个字'}]}]"></a-input>
      </a-form-item>
      <a-form-item v-bind="formItemLayout" label="角色说明">
        <a-textarea :rows="4" v-decorator="['description']"></a-textarea>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import Api from '@/api'
export default {
  name: "OperateRoleModal",
  data() {
    return {
      form: this.$form.createForm(this),
      formItemLayout: {
        labelCol: { span: 5 },
        wrapperCol: { span: 18 }
      },
      record: {},
      type:'',
      visible: false,
      confirmLoading: false
    };
  },
  methods: {
    save() {
      this.form.validateFields((err, values) => {
        if(!err) {
          this.confirmLoading =  true;
          if(this.type == 'edit') {
            Api.system.updateRole({
              name: values.name,
              description: values.description,
              id: this.record.id
            }).then(() => {
              this.confirmLoading = false;
              this.close();
              this.$emit('ok');
            })
          }else {
            Api.system.createRole({
              name: values.name,
              description: values.description,
            }).then(() => {
              this.confirmLoading = false;
              this.close();
              this.$emit('ok');
            })
          }
        }
      })
    },
    show(record) {
      this.visible = true;
      if(record) {
        this.record = record;
        this.$nextTick().then(() => {
          this.form.setFieldsValue({
            name: this.record.name,
            description: this.record.description
          });
        });
        this.type ="edit"
      }else {
        this.type = 'add'
      }
    },
    close() {
      this.visible = false;
    }
  }
};
</script>

<style scoped lang="scss">
</style>
